import { initializePack } from "lib/shared/packs";
import initializers from "initializers/base";

initializePack({
  components: require.context(
    "components",
    true,
    // eslint-disable-next-line max-len
    /^\.\/((ai_tools|bookmarks|books|classroom_resources|groups|lit_devices|navigation|poetry|quizzes|sell|shared|users|views)\/|search|payments)/
  ),
  initializers
});
